// source: nockchain/common/v1/blockchain.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var nockchain_common_v1_primitives_pb = require('../../../nockchain/common/v1/primitives_pb.js');
goog.object.extend(proto, nockchain_common_v1_primitives_pb);
var nockchain_common_v1_pagination_pb = require('../../../nockchain/common/v1/pagination_pb.js');
goog.object.extend(proto, nockchain_common_v1_pagination_pb);
goog.exportSymbol('proto.nockchain.common.v1.BalanceEntry', null, global);
goog.exportSymbol('proto.nockchain.common.v1.Input', null, global);
goog.exportSymbol('proto.nockchain.common.v1.Lock', null, global);
goog.exportSymbol('proto.nockchain.common.v1.Name', null, global);
goog.exportSymbol('proto.nockchain.common.v1.NamedInput', null, global);
goog.exportSymbol('proto.nockchain.common.v1.Note', null, global);
goog.exportSymbol('proto.nockchain.common.v1.OutputSource', null, global);
goog.exportSymbol('proto.nockchain.common.v1.RawTransaction', null, global);
goog.exportSymbol('proto.nockchain.common.v1.SchnorrSignature', null, global);
goog.exportSymbol('proto.nockchain.common.v1.Seed', null, global);
goog.exportSymbol('proto.nockchain.common.v1.Signature', null, global);
goog.exportSymbol('proto.nockchain.common.v1.SignatureEntry', null, global);
goog.exportSymbol('proto.nockchain.common.v1.Source', null, global);
goog.exportSymbol('proto.nockchain.common.v1.Spend', null, global);
goog.exportSymbol('proto.nockchain.common.v1.TimeLockIntent', null, global);
goog.exportSymbol('proto.nockchain.common.v1.TimeLockIntent.ValueCase', null, global);
goog.exportSymbol('proto.nockchain.common.v1.TimeLockRangeAbsolute', null, global);
goog.exportSymbol('proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative', null, global);
goog.exportSymbol('proto.nockchain.common.v1.TimeLockRangeNeither', null, global);
goog.exportSymbol('proto.nockchain.common.v1.TimeLockRangeRelative', null, global);
goog.exportSymbol('proto.nockchain.common.v1.WalletBalanceData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.WalletBalanceData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v1.WalletBalanceData.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v1.WalletBalanceData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.WalletBalanceData.displayName = 'proto.nockchain.common.v1.WalletBalanceData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.BalanceEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.BalanceEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.BalanceEntry.displayName = 'proto.nockchain.common.v1.BalanceEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.RawTransaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v1.RawTransaction.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v1.RawTransaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.RawTransaction.displayName = 'proto.nockchain.common.v1.RawTransaction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.NamedInput = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.NamedInput, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.NamedInput.displayName = 'proto.nockchain.common.v1.NamedInput';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Input = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.Input, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Input.displayName = 'proto.nockchain.common.v1.Input';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Spend = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v1.Spend.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v1.Spend, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Spend.displayName = 'proto.nockchain.common.v1.Spend';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Seed = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.Seed, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Seed.displayName = 'proto.nockchain.common.v1.Seed';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.OutputSource = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.OutputSource, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.OutputSource.displayName = 'proto.nockchain.common.v1.OutputSource';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Source = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.Source, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Source.displayName = 'proto.nockchain.common.v1.Source';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.TimeLockIntent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.nockchain.common.v1.TimeLockIntent.oneofGroups_);
};
goog.inherits(proto.nockchain.common.v1.TimeLockIntent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.TimeLockIntent.displayName = 'proto.nockchain.common.v1.TimeLockIntent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.TimeLockRangeNeither = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.TimeLockRangeNeither, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.TimeLockRangeNeither.displayName = 'proto.nockchain.common.v1.TimeLockRangeNeither';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.displayName = 'proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.TimeLockRangeAbsolute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.TimeLockRangeAbsolute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.TimeLockRangeAbsolute.displayName = 'proto.nockchain.common.v1.TimeLockRangeAbsolute';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.TimeLockRangeRelative = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.TimeLockRangeRelative, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.TimeLockRangeRelative.displayName = 'proto.nockchain.common.v1.TimeLockRangeRelative';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Lock = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v1.Lock.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v1.Lock, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Lock.displayName = 'proto.nockchain.common.v1.Lock';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Name = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.Name, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Name.displayName = 'proto.nockchain.common.v1.Name';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Note = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.Note, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Note.displayName = 'proto.nockchain.common.v1.Note';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.Signature = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.nockchain.common.v1.Signature.repeatedFields_, null);
};
goog.inherits(proto.nockchain.common.v1.Signature, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.Signature.displayName = 'proto.nockchain.common.v1.Signature';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.SignatureEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.SignatureEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.SignatureEntry.displayName = 'proto.nockchain.common.v1.SignatureEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.nockchain.common.v1.SchnorrSignature = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.nockchain.common.v1.SchnorrSignature, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.nockchain.common.v1.SchnorrSignature.displayName = 'proto.nockchain.common.v1.SchnorrSignature';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v1.WalletBalanceData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.WalletBalanceData.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.WalletBalanceData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.WalletBalanceData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.WalletBalanceData.toObject = function(includeInstance, msg) {
  var f, obj = {
notesList: jspb.Message.toObjectList(msg.getNotesList(),
    proto.nockchain.common.v1.BalanceEntry.toObject, includeInstance),
height: (f = msg.getHeight()) && nockchain_common_v1_primitives_pb.BlockHeight.toObject(includeInstance, f),
blockId: (f = msg.getBlockId()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
page: (f = msg.getPage()) && nockchain_common_v1_pagination_pb.PageResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.WalletBalanceData}
 */
proto.nockchain.common.v1.WalletBalanceData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.WalletBalanceData;
  return proto.nockchain.common.v1.WalletBalanceData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.WalletBalanceData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.WalletBalanceData}
 */
proto.nockchain.common.v1.WalletBalanceData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.BalanceEntry;
      reader.readMessage(value,proto.nockchain.common.v1.BalanceEntry.deserializeBinaryFromReader);
      msg.addNotes(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.BlockHeight;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.BlockHeight.deserializeBinaryFromReader);
      msg.setHeight(value);
      break;
    case 3:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setBlockId(value);
      break;
    case 4:
      var value = new nockchain_common_v1_pagination_pb.PageResponse;
      reader.readMessage(value,nockchain_common_v1_pagination_pb.PageResponse.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.WalletBalanceData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.WalletBalanceData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.WalletBalanceData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.WalletBalanceData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNotesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.nockchain.common.v1.BalanceEntry.serializeBinaryToWriter
    );
  }
  f = message.getHeight();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.BlockHeight.serializeBinaryToWriter
    );
  }
  f = message.getBlockId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      nockchain_common_v1_pagination_pb.PageResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BalanceEntry notes = 1;
 * @return {!Array<!proto.nockchain.common.v1.BalanceEntry>}
 */
proto.nockchain.common.v1.WalletBalanceData.prototype.getNotesList = function() {
  return /** @type{!Array<!proto.nockchain.common.v1.BalanceEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.common.v1.BalanceEntry, 1));
};


/**
 * @param {!Array<!proto.nockchain.common.v1.BalanceEntry>} value
 * @return {!proto.nockchain.common.v1.WalletBalanceData} returns this
*/
proto.nockchain.common.v1.WalletBalanceData.prototype.setNotesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.nockchain.common.v1.BalanceEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v1.BalanceEntry}
 */
proto.nockchain.common.v1.WalletBalanceData.prototype.addNotes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.nockchain.common.v1.BalanceEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v1.WalletBalanceData} returns this
 */
proto.nockchain.common.v1.WalletBalanceData.prototype.clearNotesList = function() {
  return this.setNotesList([]);
};


/**
 * optional BlockHeight height = 2;
 * @return {?proto.nockchain.common.v1.BlockHeight}
 */
proto.nockchain.common.v1.WalletBalanceData.prototype.getHeight = function() {
  return /** @type{?proto.nockchain.common.v1.BlockHeight} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.BlockHeight, 2));
};


/**
 * @param {?proto.nockchain.common.v1.BlockHeight|undefined} value
 * @return {!proto.nockchain.common.v1.WalletBalanceData} returns this
*/
proto.nockchain.common.v1.WalletBalanceData.prototype.setHeight = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.WalletBalanceData} returns this
 */
proto.nockchain.common.v1.WalletBalanceData.prototype.clearHeight = function() {
  return this.setHeight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.WalletBalanceData.prototype.hasHeight = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Hash block_id = 3;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v1.WalletBalanceData.prototype.getBlockId = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 3));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.common.v1.WalletBalanceData} returns this
*/
proto.nockchain.common.v1.WalletBalanceData.prototype.setBlockId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.WalletBalanceData} returns this
 */
proto.nockchain.common.v1.WalletBalanceData.prototype.clearBlockId = function() {
  return this.setBlockId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.WalletBalanceData.prototype.hasBlockId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PageResponse page = 4;
 * @return {?proto.nockchain.common.v1.PageResponse}
 */
proto.nockchain.common.v1.WalletBalanceData.prototype.getPage = function() {
  return /** @type{?proto.nockchain.common.v1.PageResponse} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_pagination_pb.PageResponse, 4));
};


/**
 * @param {?proto.nockchain.common.v1.PageResponse|undefined} value
 * @return {!proto.nockchain.common.v1.WalletBalanceData} returns this
*/
proto.nockchain.common.v1.WalletBalanceData.prototype.setPage = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.WalletBalanceData} returns this
 */
proto.nockchain.common.v1.WalletBalanceData.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.WalletBalanceData.prototype.hasPage = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.BalanceEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.BalanceEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.BalanceEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.BalanceEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
name: (f = msg.getName()) && proto.nockchain.common.v1.Name.toObject(includeInstance, f),
note: (f = msg.getNote()) && proto.nockchain.common.v1.Note.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.BalanceEntry}
 */
proto.nockchain.common.v1.BalanceEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.BalanceEntry;
  return proto.nockchain.common.v1.BalanceEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.BalanceEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.BalanceEntry}
 */
proto.nockchain.common.v1.BalanceEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.Name;
      reader.readMessage(value,proto.nockchain.common.v1.Name.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v1.Note;
      reader.readMessage(value,proto.nockchain.common.v1.Note.deserializeBinaryFromReader);
      msg.setNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.BalanceEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.BalanceEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.BalanceEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.BalanceEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v1.Name.serializeBinaryToWriter
    );
  }
  f = message.getNote();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v1.Note.serializeBinaryToWriter
    );
  }
};


/**
 * optional Name name = 1;
 * @return {?proto.nockchain.common.v1.Name}
 */
proto.nockchain.common.v1.BalanceEntry.prototype.getName = function() {
  return /** @type{?proto.nockchain.common.v1.Name} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Name, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Name|undefined} value
 * @return {!proto.nockchain.common.v1.BalanceEntry} returns this
*/
proto.nockchain.common.v1.BalanceEntry.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.BalanceEntry} returns this
 */
proto.nockchain.common.v1.BalanceEntry.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.BalanceEntry.prototype.hasName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Note note = 2;
 * @return {?proto.nockchain.common.v1.Note}
 */
proto.nockchain.common.v1.BalanceEntry.prototype.getNote = function() {
  return /** @type{?proto.nockchain.common.v1.Note} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Note, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Note|undefined} value
 * @return {!proto.nockchain.common.v1.BalanceEntry} returns this
*/
proto.nockchain.common.v1.BalanceEntry.prototype.setNote = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.BalanceEntry} returns this
 */
proto.nockchain.common.v1.BalanceEntry.prototype.clearNote = function() {
  return this.setNote(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.BalanceEntry.prototype.hasNote = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v1.RawTransaction.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.RawTransaction.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.RawTransaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.RawTransaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.RawTransaction.toObject = function(includeInstance, msg) {
  var f, obj = {
namedInputsList: jspb.Message.toObjectList(msg.getNamedInputsList(),
    proto.nockchain.common.v1.NamedInput.toObject, includeInstance),
timelockRange: (f = msg.getTimelockRange()) && proto.nockchain.common.v1.TimeLockRangeAbsolute.toObject(includeInstance, f),
totalFees: (f = msg.getTotalFees()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f),
id: (f = msg.getId()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.RawTransaction}
 */
proto.nockchain.common.v1.RawTransaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.RawTransaction;
  return proto.nockchain.common.v1.RawTransaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.RawTransaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.RawTransaction}
 */
proto.nockchain.common.v1.RawTransaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.NamedInput;
      reader.readMessage(value,proto.nockchain.common.v1.NamedInput.deserializeBinaryFromReader);
      msg.addNamedInputs(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v1.TimeLockRangeAbsolute;
      reader.readMessage(value,proto.nockchain.common.v1.TimeLockRangeAbsolute.deserializeBinaryFromReader);
      msg.setTimelockRange(value);
      break;
    case 3:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setTotalFees(value);
      break;
    case 4:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.RawTransaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.RawTransaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.RawTransaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.RawTransaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNamedInputsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.nockchain.common.v1.NamedInput.serializeBinaryToWriter
    );
  }
  f = message.getTimelockRange();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v1.TimeLockRangeAbsolute.serializeBinaryToWriter
    );
  }
  f = message.getTotalFees();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
};


/**
 * repeated NamedInput named_inputs = 1;
 * @return {!Array<!proto.nockchain.common.v1.NamedInput>}
 */
proto.nockchain.common.v1.RawTransaction.prototype.getNamedInputsList = function() {
  return /** @type{!Array<!proto.nockchain.common.v1.NamedInput>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.common.v1.NamedInput, 1));
};


/**
 * @param {!Array<!proto.nockchain.common.v1.NamedInput>} value
 * @return {!proto.nockchain.common.v1.RawTransaction} returns this
*/
proto.nockchain.common.v1.RawTransaction.prototype.setNamedInputsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.nockchain.common.v1.NamedInput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v1.NamedInput}
 */
proto.nockchain.common.v1.RawTransaction.prototype.addNamedInputs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.nockchain.common.v1.NamedInput, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v1.RawTransaction} returns this
 */
proto.nockchain.common.v1.RawTransaction.prototype.clearNamedInputsList = function() {
  return this.setNamedInputsList([]);
};


/**
 * optional TimeLockRangeAbsolute timelock_range = 2;
 * @return {?proto.nockchain.common.v1.TimeLockRangeAbsolute}
 */
proto.nockchain.common.v1.RawTransaction.prototype.getTimelockRange = function() {
  return /** @type{?proto.nockchain.common.v1.TimeLockRangeAbsolute} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.TimeLockRangeAbsolute, 2));
};


/**
 * @param {?proto.nockchain.common.v1.TimeLockRangeAbsolute|undefined} value
 * @return {!proto.nockchain.common.v1.RawTransaction} returns this
*/
proto.nockchain.common.v1.RawTransaction.prototype.setTimelockRange = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.RawTransaction} returns this
 */
proto.nockchain.common.v1.RawTransaction.prototype.clearTimelockRange = function() {
  return this.setTimelockRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.RawTransaction.prototype.hasTimelockRange = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Nicks total_fees = 3;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.common.v1.RawTransaction.prototype.getTotalFees = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 3));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.common.v1.RawTransaction} returns this
*/
proto.nockchain.common.v1.RawTransaction.prototype.setTotalFees = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.RawTransaction} returns this
 */
proto.nockchain.common.v1.RawTransaction.prototype.clearTotalFees = function() {
  return this.setTotalFees(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.RawTransaction.prototype.hasTotalFees = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Hash id = 4;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v1.RawTransaction.prototype.getId = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 4));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.common.v1.RawTransaction} returns this
*/
proto.nockchain.common.v1.RawTransaction.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.RawTransaction} returns this
 */
proto.nockchain.common.v1.RawTransaction.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.RawTransaction.prototype.hasId = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.NamedInput.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.NamedInput.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.NamedInput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.NamedInput.toObject = function(includeInstance, msg) {
  var f, obj = {
name: (f = msg.getName()) && proto.nockchain.common.v1.Name.toObject(includeInstance, f),
input: (f = msg.getInput()) && proto.nockchain.common.v1.Input.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.NamedInput}
 */
proto.nockchain.common.v1.NamedInput.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.NamedInput;
  return proto.nockchain.common.v1.NamedInput.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.NamedInput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.NamedInput}
 */
proto.nockchain.common.v1.NamedInput.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.Name;
      reader.readMessage(value,proto.nockchain.common.v1.Name.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v1.Input;
      reader.readMessage(value,proto.nockchain.common.v1.Input.deserializeBinaryFromReader);
      msg.setInput(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.NamedInput.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.NamedInput.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.NamedInput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.NamedInput.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v1.Name.serializeBinaryToWriter
    );
  }
  f = message.getInput();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v1.Input.serializeBinaryToWriter
    );
  }
};


/**
 * optional Name name = 1;
 * @return {?proto.nockchain.common.v1.Name}
 */
proto.nockchain.common.v1.NamedInput.prototype.getName = function() {
  return /** @type{?proto.nockchain.common.v1.Name} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Name, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Name|undefined} value
 * @return {!proto.nockchain.common.v1.NamedInput} returns this
*/
proto.nockchain.common.v1.NamedInput.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.NamedInput} returns this
 */
proto.nockchain.common.v1.NamedInput.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.NamedInput.prototype.hasName = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Input input = 2;
 * @return {?proto.nockchain.common.v1.Input}
 */
proto.nockchain.common.v1.NamedInput.prototype.getInput = function() {
  return /** @type{?proto.nockchain.common.v1.Input} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Input, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Input|undefined} value
 * @return {!proto.nockchain.common.v1.NamedInput} returns this
*/
proto.nockchain.common.v1.NamedInput.prototype.setInput = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.NamedInput} returns this
 */
proto.nockchain.common.v1.NamedInput.prototype.clearInput = function() {
  return this.setInput(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.NamedInput.prototype.hasInput = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Input.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Input.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Input} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Input.toObject = function(includeInstance, msg) {
  var f, obj = {
note: (f = msg.getNote()) && proto.nockchain.common.v1.Note.toObject(includeInstance, f),
spend: (f = msg.getSpend()) && proto.nockchain.common.v1.Spend.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Input}
 */
proto.nockchain.common.v1.Input.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Input;
  return proto.nockchain.common.v1.Input.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Input} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Input}
 */
proto.nockchain.common.v1.Input.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.Note;
      reader.readMessage(value,proto.nockchain.common.v1.Note.deserializeBinaryFromReader);
      msg.setNote(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v1.Spend;
      reader.readMessage(value,proto.nockchain.common.v1.Spend.deserializeBinaryFromReader);
      msg.setSpend(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Input.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Input.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Input} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Input.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNote();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v1.Note.serializeBinaryToWriter
    );
  }
  f = message.getSpend();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v1.Spend.serializeBinaryToWriter
    );
  }
};


/**
 * optional Note note = 1;
 * @return {?proto.nockchain.common.v1.Note}
 */
proto.nockchain.common.v1.Input.prototype.getNote = function() {
  return /** @type{?proto.nockchain.common.v1.Note} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Note, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Note|undefined} value
 * @return {!proto.nockchain.common.v1.Input} returns this
*/
proto.nockchain.common.v1.Input.prototype.setNote = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Input} returns this
 */
proto.nockchain.common.v1.Input.prototype.clearNote = function() {
  return this.setNote(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Input.prototype.hasNote = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Spend spend = 2;
 * @return {?proto.nockchain.common.v1.Spend}
 */
proto.nockchain.common.v1.Input.prototype.getSpend = function() {
  return /** @type{?proto.nockchain.common.v1.Spend} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Spend, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Spend|undefined} value
 * @return {!proto.nockchain.common.v1.Input} returns this
*/
proto.nockchain.common.v1.Input.prototype.setSpend = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Input} returns this
 */
proto.nockchain.common.v1.Input.prototype.clearSpend = function() {
  return this.setSpend(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Input.prototype.hasSpend = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v1.Spend.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Spend.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Spend.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Spend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Spend.toObject = function(includeInstance, msg) {
  var f, obj = {
signature: (f = msg.getSignature()) && proto.nockchain.common.v1.Signature.toObject(includeInstance, f),
seedsList: jspb.Message.toObjectList(msg.getSeedsList(),
    proto.nockchain.common.v1.Seed.toObject, includeInstance),
minerFeeNicks: (f = msg.getMinerFeeNicks()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Spend}
 */
proto.nockchain.common.v1.Spend.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Spend;
  return proto.nockchain.common.v1.Spend.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Spend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Spend}
 */
proto.nockchain.common.v1.Spend.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.Signature;
      reader.readMessage(value,proto.nockchain.common.v1.Signature.deserializeBinaryFromReader);
      msg.setSignature(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v1.Seed;
      reader.readMessage(value,proto.nockchain.common.v1.Seed.deserializeBinaryFromReader);
      msg.addSeeds(value);
      break;
    case 3:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setMinerFeeNicks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Spend.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Spend.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Spend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Spend.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSignature();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v1.Signature.serializeBinaryToWriter
    );
  }
  f = message.getSeedsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.nockchain.common.v1.Seed.serializeBinaryToWriter
    );
  }
  f = message.getMinerFeeNicks();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
};


/**
 * optional Signature signature = 1;
 * @return {?proto.nockchain.common.v1.Signature}
 */
proto.nockchain.common.v1.Spend.prototype.getSignature = function() {
  return /** @type{?proto.nockchain.common.v1.Signature} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Signature, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Signature|undefined} value
 * @return {!proto.nockchain.common.v1.Spend} returns this
*/
proto.nockchain.common.v1.Spend.prototype.setSignature = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Spend} returns this
 */
proto.nockchain.common.v1.Spend.prototype.clearSignature = function() {
  return this.setSignature(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Spend.prototype.hasSignature = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Seed seeds = 2;
 * @return {!Array<!proto.nockchain.common.v1.Seed>}
 */
proto.nockchain.common.v1.Spend.prototype.getSeedsList = function() {
  return /** @type{!Array<!proto.nockchain.common.v1.Seed>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.common.v1.Seed, 2));
};


/**
 * @param {!Array<!proto.nockchain.common.v1.Seed>} value
 * @return {!proto.nockchain.common.v1.Spend} returns this
*/
proto.nockchain.common.v1.Spend.prototype.setSeedsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.nockchain.common.v1.Seed=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v1.Seed}
 */
proto.nockchain.common.v1.Spend.prototype.addSeeds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.nockchain.common.v1.Seed, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v1.Spend} returns this
 */
proto.nockchain.common.v1.Spend.prototype.clearSeedsList = function() {
  return this.setSeedsList([]);
};


/**
 * optional Nicks miner_fee_nicks = 3;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.common.v1.Spend.prototype.getMinerFeeNicks = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 3));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.common.v1.Spend} returns this
*/
proto.nockchain.common.v1.Spend.prototype.setMinerFeeNicks = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Spend} returns this
 */
proto.nockchain.common.v1.Spend.prototype.clearMinerFeeNicks = function() {
  return this.setMinerFeeNicks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Spend.prototype.hasMinerFeeNicks = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Seed.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Seed.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Seed} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Seed.toObject = function(includeInstance, msg) {
  var f, obj = {
outputSource: (f = msg.getOutputSource()) && proto.nockchain.common.v1.OutputSource.toObject(includeInstance, f),
recipient: (f = msg.getRecipient()) && proto.nockchain.common.v1.Lock.toObject(includeInstance, f),
timelockIntent: (f = msg.getTimelockIntent()) && proto.nockchain.common.v1.TimeLockIntent.toObject(includeInstance, f),
gift: (f = msg.getGift()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f),
parentHash: (f = msg.getParentHash()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Seed}
 */
proto.nockchain.common.v1.Seed.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Seed;
  return proto.nockchain.common.v1.Seed.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Seed} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Seed}
 */
proto.nockchain.common.v1.Seed.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.OutputSource;
      reader.readMessage(value,proto.nockchain.common.v1.OutputSource.deserializeBinaryFromReader);
      msg.setOutputSource(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v1.Lock;
      reader.readMessage(value,proto.nockchain.common.v1.Lock.deserializeBinaryFromReader);
      msg.setRecipient(value);
      break;
    case 3:
      var value = new proto.nockchain.common.v1.TimeLockIntent;
      reader.readMessage(value,proto.nockchain.common.v1.TimeLockIntent.deserializeBinaryFromReader);
      msg.setTimelockIntent(value);
      break;
    case 4:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setGift(value);
      break;
    case 5:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setParentHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Seed.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Seed.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Seed} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Seed.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOutputSource();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v1.OutputSource.serializeBinaryToWriter
    );
  }
  f = message.getRecipient();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v1.Lock.serializeBinaryToWriter
    );
  }
  f = message.getTimelockIntent();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.nockchain.common.v1.TimeLockIntent.serializeBinaryToWriter
    );
  }
  f = message.getGift();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
  f = message.getParentHash();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
};


/**
 * optional OutputSource output_source = 1;
 * @return {?proto.nockchain.common.v1.OutputSource}
 */
proto.nockchain.common.v1.Seed.prototype.getOutputSource = function() {
  return /** @type{?proto.nockchain.common.v1.OutputSource} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.OutputSource, 1));
};


/**
 * @param {?proto.nockchain.common.v1.OutputSource|undefined} value
 * @return {!proto.nockchain.common.v1.Seed} returns this
*/
proto.nockchain.common.v1.Seed.prototype.setOutputSource = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Seed} returns this
 */
proto.nockchain.common.v1.Seed.prototype.clearOutputSource = function() {
  return this.setOutputSource(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Seed.prototype.hasOutputSource = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Lock recipient = 2;
 * @return {?proto.nockchain.common.v1.Lock}
 */
proto.nockchain.common.v1.Seed.prototype.getRecipient = function() {
  return /** @type{?proto.nockchain.common.v1.Lock} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Lock, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Lock|undefined} value
 * @return {!proto.nockchain.common.v1.Seed} returns this
*/
proto.nockchain.common.v1.Seed.prototype.setRecipient = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Seed} returns this
 */
proto.nockchain.common.v1.Seed.prototype.clearRecipient = function() {
  return this.setRecipient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Seed.prototype.hasRecipient = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TimeLockIntent timelock_intent = 3;
 * @return {?proto.nockchain.common.v1.TimeLockIntent}
 */
proto.nockchain.common.v1.Seed.prototype.getTimelockIntent = function() {
  return /** @type{?proto.nockchain.common.v1.TimeLockIntent} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.TimeLockIntent, 3));
};


/**
 * @param {?proto.nockchain.common.v1.TimeLockIntent|undefined} value
 * @return {!proto.nockchain.common.v1.Seed} returns this
*/
proto.nockchain.common.v1.Seed.prototype.setTimelockIntent = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Seed} returns this
 */
proto.nockchain.common.v1.Seed.prototype.clearTimelockIntent = function() {
  return this.setTimelockIntent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Seed.prototype.hasTimelockIntent = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Nicks gift = 4;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.common.v1.Seed.prototype.getGift = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 4));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.common.v1.Seed} returns this
*/
proto.nockchain.common.v1.Seed.prototype.setGift = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Seed} returns this
 */
proto.nockchain.common.v1.Seed.prototype.clearGift = function() {
  return this.setGift(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Seed.prototype.hasGift = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Hash parent_hash = 5;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v1.Seed.prototype.getParentHash = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 5));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.common.v1.Seed} returns this
*/
proto.nockchain.common.v1.Seed.prototype.setParentHash = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Seed} returns this
 */
proto.nockchain.common.v1.Seed.prototype.clearParentHash = function() {
  return this.setParentHash(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Seed.prototype.hasParentHash = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.OutputSource.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.OutputSource.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.OutputSource} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.OutputSource.toObject = function(includeInstance, msg) {
  var f, obj = {
source: (f = msg.getSource()) && proto.nockchain.common.v1.Source.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.OutputSource}
 */
proto.nockchain.common.v1.OutputSource.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.OutputSource;
  return proto.nockchain.common.v1.OutputSource.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.OutputSource} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.OutputSource}
 */
proto.nockchain.common.v1.OutputSource.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.Source;
      reader.readMessage(value,proto.nockchain.common.v1.Source.deserializeBinaryFromReader);
      msg.setSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.OutputSource.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.OutputSource.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.OutputSource} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.OutputSource.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v1.Source.serializeBinaryToWriter
    );
  }
};


/**
 * optional Source source = 1;
 * @return {?proto.nockchain.common.v1.Source}
 */
proto.nockchain.common.v1.OutputSource.prototype.getSource = function() {
  return /** @type{?proto.nockchain.common.v1.Source} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Source, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Source|undefined} value
 * @return {!proto.nockchain.common.v1.OutputSource} returns this
*/
proto.nockchain.common.v1.OutputSource.prototype.setSource = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.OutputSource} returns this
 */
proto.nockchain.common.v1.OutputSource.prototype.clearSource = function() {
  return this.setSource(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.OutputSource.prototype.hasSource = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Source.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Source.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Source} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Source.toObject = function(includeInstance, msg) {
  var f, obj = {
hash: (f = msg.getHash()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
coinbase: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Source}
 */
proto.nockchain.common.v1.Source.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Source;
  return proto.nockchain.common.v1.Source.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Source} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Source}
 */
proto.nockchain.common.v1.Source.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setHash(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCoinbase(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Source.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Source.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Source} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Source.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHash();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getCoinbase();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional Hash hash = 1;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v1.Source.prototype.getHash = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.common.v1.Source} returns this
*/
proto.nockchain.common.v1.Source.prototype.setHash = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Source} returns this
 */
proto.nockchain.common.v1.Source.prototype.clearHash = function() {
  return this.setHash(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Source.prototype.hasHash = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool coinbase = 2;
 * @return {boolean}
 */
proto.nockchain.common.v1.Source.prototype.getCoinbase = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.nockchain.common.v1.Source} returns this
 */
proto.nockchain.common.v1.Source.prototype.setCoinbase = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.nockchain.common.v1.TimeLockIntent.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.nockchain.common.v1.TimeLockIntent.ValueCase = {
  VALUE_NOT_SET: 0,
  ABSOLUTE: 1,
  RELATIVE: 2,
  ABSOLUTE_AND_RELATIVE: 3,
  NEITHER: 4
};

/**
 * @return {proto.nockchain.common.v1.TimeLockIntent.ValueCase}
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.getValueCase = function() {
  return /** @type {proto.nockchain.common.v1.TimeLockIntent.ValueCase} */(jspb.Message.computeOneofCase(this, proto.nockchain.common.v1.TimeLockIntent.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.TimeLockIntent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.TimeLockIntent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.TimeLockIntent.toObject = function(includeInstance, msg) {
  var f, obj = {
absolute: (f = msg.getAbsolute()) && proto.nockchain.common.v1.TimeLockRangeAbsolute.toObject(includeInstance, f),
relative: (f = msg.getRelative()) && proto.nockchain.common.v1.TimeLockRangeRelative.toObject(includeInstance, f),
absoluteAndRelative: (f = msg.getAbsoluteAndRelative()) && proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.toObject(includeInstance, f),
neither: (f = msg.getNeither()) && proto.nockchain.common.v1.TimeLockRangeNeither.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.TimeLockIntent}
 */
proto.nockchain.common.v1.TimeLockIntent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.TimeLockIntent;
  return proto.nockchain.common.v1.TimeLockIntent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.TimeLockIntent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.TimeLockIntent}
 */
proto.nockchain.common.v1.TimeLockIntent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.TimeLockRangeAbsolute;
      reader.readMessage(value,proto.nockchain.common.v1.TimeLockRangeAbsolute.deserializeBinaryFromReader);
      msg.setAbsolute(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v1.TimeLockRangeRelative;
      reader.readMessage(value,proto.nockchain.common.v1.TimeLockRangeRelative.deserializeBinaryFromReader);
      msg.setRelative(value);
      break;
    case 3:
      var value = new proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative;
      reader.readMessage(value,proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.deserializeBinaryFromReader);
      msg.setAbsoluteAndRelative(value);
      break;
    case 4:
      var value = new proto.nockchain.common.v1.TimeLockRangeNeither;
      reader.readMessage(value,proto.nockchain.common.v1.TimeLockRangeNeither.deserializeBinaryFromReader);
      msg.setNeither(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.TimeLockIntent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.TimeLockIntent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.TimeLockIntent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAbsolute();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v1.TimeLockRangeAbsolute.serializeBinaryToWriter
    );
  }
  f = message.getRelative();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v1.TimeLockRangeRelative.serializeBinaryToWriter
    );
  }
  f = message.getAbsoluteAndRelative();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.serializeBinaryToWriter
    );
  }
  f = message.getNeither();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.nockchain.common.v1.TimeLockRangeNeither.serializeBinaryToWriter
    );
  }
};


/**
 * optional TimeLockRangeAbsolute absolute = 1;
 * @return {?proto.nockchain.common.v1.TimeLockRangeAbsolute}
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.getAbsolute = function() {
  return /** @type{?proto.nockchain.common.v1.TimeLockRangeAbsolute} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.TimeLockRangeAbsolute, 1));
};


/**
 * @param {?proto.nockchain.common.v1.TimeLockRangeAbsolute|undefined} value
 * @return {!proto.nockchain.common.v1.TimeLockIntent} returns this
*/
proto.nockchain.common.v1.TimeLockIntent.prototype.setAbsolute = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.nockchain.common.v1.TimeLockIntent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.TimeLockIntent} returns this
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.clearAbsolute = function() {
  return this.setAbsolute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.hasAbsolute = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TimeLockRangeRelative relative = 2;
 * @return {?proto.nockchain.common.v1.TimeLockRangeRelative}
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.getRelative = function() {
  return /** @type{?proto.nockchain.common.v1.TimeLockRangeRelative} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.TimeLockRangeRelative, 2));
};


/**
 * @param {?proto.nockchain.common.v1.TimeLockRangeRelative|undefined} value
 * @return {!proto.nockchain.common.v1.TimeLockIntent} returns this
*/
proto.nockchain.common.v1.TimeLockIntent.prototype.setRelative = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.nockchain.common.v1.TimeLockIntent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.TimeLockIntent} returns this
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.clearRelative = function() {
  return this.setRelative(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.hasRelative = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TimeLockRangeAbsoluteAndRelative absolute_and_relative = 3;
 * @return {?proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative}
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.getAbsoluteAndRelative = function() {
  return /** @type{?proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative, 3));
};


/**
 * @param {?proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative|undefined} value
 * @return {!proto.nockchain.common.v1.TimeLockIntent} returns this
*/
proto.nockchain.common.v1.TimeLockIntent.prototype.setAbsoluteAndRelative = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.nockchain.common.v1.TimeLockIntent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.TimeLockIntent} returns this
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.clearAbsoluteAndRelative = function() {
  return this.setAbsoluteAndRelative(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.hasAbsoluteAndRelative = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TimeLockRangeNeither neither = 4;
 * @return {?proto.nockchain.common.v1.TimeLockRangeNeither}
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.getNeither = function() {
  return /** @type{?proto.nockchain.common.v1.TimeLockRangeNeither} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.TimeLockRangeNeither, 4));
};


/**
 * @param {?proto.nockchain.common.v1.TimeLockRangeNeither|undefined} value
 * @return {!proto.nockchain.common.v1.TimeLockIntent} returns this
*/
proto.nockchain.common.v1.TimeLockIntent.prototype.setNeither = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.nockchain.common.v1.TimeLockIntent.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.TimeLockIntent} returns this
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.clearNeither = function() {
  return this.setNeither(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.TimeLockIntent.prototype.hasNeither = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.TimeLockRangeNeither.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.TimeLockRangeNeither.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.TimeLockRangeNeither} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.TimeLockRangeNeither.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.TimeLockRangeNeither}
 */
proto.nockchain.common.v1.TimeLockRangeNeither.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.TimeLockRangeNeither;
  return proto.nockchain.common.v1.TimeLockRangeNeither.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.TimeLockRangeNeither} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.TimeLockRangeNeither}
 */
proto.nockchain.common.v1.TimeLockRangeNeither.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.TimeLockRangeNeither.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.TimeLockRangeNeither.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.TimeLockRangeNeither} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.TimeLockRangeNeither.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.toObject = function(includeInstance, msg) {
  var f, obj = {
absolute: (f = msg.getAbsolute()) && proto.nockchain.common.v1.TimeLockRangeAbsolute.toObject(includeInstance, f),
relative: (f = msg.getRelative()) && proto.nockchain.common.v1.TimeLockRangeRelative.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative}
 */
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative;
  return proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative}
 */
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.TimeLockRangeAbsolute;
      reader.readMessage(value,proto.nockchain.common.v1.TimeLockRangeAbsolute.deserializeBinaryFromReader);
      msg.setAbsolute(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v1.TimeLockRangeRelative;
      reader.readMessage(value,proto.nockchain.common.v1.TimeLockRangeRelative.deserializeBinaryFromReader);
      msg.setRelative(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAbsolute();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.nockchain.common.v1.TimeLockRangeAbsolute.serializeBinaryToWriter
    );
  }
  f = message.getRelative();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v1.TimeLockRangeRelative.serializeBinaryToWriter
    );
  }
};


/**
 * optional TimeLockRangeAbsolute absolute = 1;
 * @return {?proto.nockchain.common.v1.TimeLockRangeAbsolute}
 */
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.prototype.getAbsolute = function() {
  return /** @type{?proto.nockchain.common.v1.TimeLockRangeAbsolute} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.TimeLockRangeAbsolute, 1));
};


/**
 * @param {?proto.nockchain.common.v1.TimeLockRangeAbsolute|undefined} value
 * @return {!proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative} returns this
*/
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.prototype.setAbsolute = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative} returns this
 */
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.prototype.clearAbsolute = function() {
  return this.setAbsolute(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.prototype.hasAbsolute = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TimeLockRangeRelative relative = 2;
 * @return {?proto.nockchain.common.v1.TimeLockRangeRelative}
 */
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.prototype.getRelative = function() {
  return /** @type{?proto.nockchain.common.v1.TimeLockRangeRelative} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.TimeLockRangeRelative, 2));
};


/**
 * @param {?proto.nockchain.common.v1.TimeLockRangeRelative|undefined} value
 * @return {!proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative} returns this
*/
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.prototype.setRelative = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative} returns this
 */
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.prototype.clearRelative = function() {
  return this.setRelative(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.TimeLockRangeAbsoluteAndRelative.prototype.hasRelative = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.TimeLockRangeAbsolute.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.TimeLockRangeAbsolute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.TimeLockRangeAbsolute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.TimeLockRangeAbsolute.toObject = function(includeInstance, msg) {
  var f, obj = {
min: (f = msg.getMin()) && nockchain_common_v1_primitives_pb.BlockHeight.toObject(includeInstance, f),
max: (f = msg.getMax()) && nockchain_common_v1_primitives_pb.BlockHeight.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.TimeLockRangeAbsolute}
 */
proto.nockchain.common.v1.TimeLockRangeAbsolute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.TimeLockRangeAbsolute;
  return proto.nockchain.common.v1.TimeLockRangeAbsolute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.TimeLockRangeAbsolute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.TimeLockRangeAbsolute}
 */
proto.nockchain.common.v1.TimeLockRangeAbsolute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.BlockHeight;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.BlockHeight.deserializeBinaryFromReader);
      msg.setMin(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.BlockHeight;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.BlockHeight.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.TimeLockRangeAbsolute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.TimeLockRangeAbsolute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.TimeLockRangeAbsolute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.TimeLockRangeAbsolute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.BlockHeight.serializeBinaryToWriter
    );
  }
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.BlockHeight.serializeBinaryToWriter
    );
  }
};


/**
 * optional BlockHeight min = 1;
 * @return {?proto.nockchain.common.v1.BlockHeight}
 */
proto.nockchain.common.v1.TimeLockRangeAbsolute.prototype.getMin = function() {
  return /** @type{?proto.nockchain.common.v1.BlockHeight} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.BlockHeight, 1));
};


/**
 * @param {?proto.nockchain.common.v1.BlockHeight|undefined} value
 * @return {!proto.nockchain.common.v1.TimeLockRangeAbsolute} returns this
*/
proto.nockchain.common.v1.TimeLockRangeAbsolute.prototype.setMin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.TimeLockRangeAbsolute} returns this
 */
proto.nockchain.common.v1.TimeLockRangeAbsolute.prototype.clearMin = function() {
  return this.setMin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.TimeLockRangeAbsolute.prototype.hasMin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional BlockHeight max = 2;
 * @return {?proto.nockchain.common.v1.BlockHeight}
 */
proto.nockchain.common.v1.TimeLockRangeAbsolute.prototype.getMax = function() {
  return /** @type{?proto.nockchain.common.v1.BlockHeight} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.BlockHeight, 2));
};


/**
 * @param {?proto.nockchain.common.v1.BlockHeight|undefined} value
 * @return {!proto.nockchain.common.v1.TimeLockRangeAbsolute} returns this
*/
proto.nockchain.common.v1.TimeLockRangeAbsolute.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.TimeLockRangeAbsolute} returns this
 */
proto.nockchain.common.v1.TimeLockRangeAbsolute.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.TimeLockRangeAbsolute.prototype.hasMax = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.TimeLockRangeRelative.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.TimeLockRangeRelative.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.TimeLockRangeRelative} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.TimeLockRangeRelative.toObject = function(includeInstance, msg) {
  var f, obj = {
min: (f = msg.getMin()) && nockchain_common_v1_primitives_pb.BlockHeightDelta.toObject(includeInstance, f),
max: (f = msg.getMax()) && nockchain_common_v1_primitives_pb.BlockHeightDelta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.TimeLockRangeRelative}
 */
proto.nockchain.common.v1.TimeLockRangeRelative.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.TimeLockRangeRelative;
  return proto.nockchain.common.v1.TimeLockRangeRelative.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.TimeLockRangeRelative} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.TimeLockRangeRelative}
 */
proto.nockchain.common.v1.TimeLockRangeRelative.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.BlockHeightDelta;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.BlockHeightDelta.deserializeBinaryFromReader);
      msg.setMin(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.BlockHeightDelta;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.BlockHeightDelta.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.TimeLockRangeRelative.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.TimeLockRangeRelative.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.TimeLockRangeRelative} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.TimeLockRangeRelative.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMin();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.BlockHeightDelta.serializeBinaryToWriter
    );
  }
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.BlockHeightDelta.serializeBinaryToWriter
    );
  }
};


/**
 * optional BlockHeightDelta min = 1;
 * @return {?proto.nockchain.common.v1.BlockHeightDelta}
 */
proto.nockchain.common.v1.TimeLockRangeRelative.prototype.getMin = function() {
  return /** @type{?proto.nockchain.common.v1.BlockHeightDelta} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.BlockHeightDelta, 1));
};


/**
 * @param {?proto.nockchain.common.v1.BlockHeightDelta|undefined} value
 * @return {!proto.nockchain.common.v1.TimeLockRangeRelative} returns this
*/
proto.nockchain.common.v1.TimeLockRangeRelative.prototype.setMin = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.TimeLockRangeRelative} returns this
 */
proto.nockchain.common.v1.TimeLockRangeRelative.prototype.clearMin = function() {
  return this.setMin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.TimeLockRangeRelative.prototype.hasMin = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional BlockHeightDelta max = 2;
 * @return {?proto.nockchain.common.v1.BlockHeightDelta}
 */
proto.nockchain.common.v1.TimeLockRangeRelative.prototype.getMax = function() {
  return /** @type{?proto.nockchain.common.v1.BlockHeightDelta} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.BlockHeightDelta, 2));
};


/**
 * @param {?proto.nockchain.common.v1.BlockHeightDelta|undefined} value
 * @return {!proto.nockchain.common.v1.TimeLockRangeRelative} returns this
*/
proto.nockchain.common.v1.TimeLockRangeRelative.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.TimeLockRangeRelative} returns this
 */
proto.nockchain.common.v1.TimeLockRangeRelative.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.TimeLockRangeRelative.prototype.hasMax = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v1.Lock.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Lock.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Lock.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Lock} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Lock.toObject = function(includeInstance, msg) {
  var f, obj = {
keysRequired: jspb.Message.getFieldWithDefault(msg, 1, 0),
schnorrPubkeysList: jspb.Message.toObjectList(msg.getSchnorrPubkeysList(),
    nockchain_common_v1_primitives_pb.SchnorrPubkey.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Lock}
 */
proto.nockchain.common.v1.Lock.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Lock;
  return proto.nockchain.common.v1.Lock.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Lock} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Lock}
 */
proto.nockchain.common.v1.Lock.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKeysRequired(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.SchnorrPubkey;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.SchnorrPubkey.deserializeBinaryFromReader);
      msg.addSchnorrPubkeys(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Lock.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Lock.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Lock} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Lock.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKeysRequired();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSchnorrPubkeysList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.SchnorrPubkey.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 keys_required = 1;
 * @return {number}
 */
proto.nockchain.common.v1.Lock.prototype.getKeysRequired = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.nockchain.common.v1.Lock} returns this
 */
proto.nockchain.common.v1.Lock.prototype.setKeysRequired = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated SchnorrPubkey schnorr_pubkeys = 2;
 * @return {!Array<!proto.nockchain.common.v1.SchnorrPubkey>}
 */
proto.nockchain.common.v1.Lock.prototype.getSchnorrPubkeysList = function() {
  return /** @type{!Array<!proto.nockchain.common.v1.SchnorrPubkey>} */ (
    jspb.Message.getRepeatedWrapperField(this, nockchain_common_v1_primitives_pb.SchnorrPubkey, 2));
};


/**
 * @param {!Array<!proto.nockchain.common.v1.SchnorrPubkey>} value
 * @return {!proto.nockchain.common.v1.Lock} returns this
*/
proto.nockchain.common.v1.Lock.prototype.setSchnorrPubkeysList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.nockchain.common.v1.SchnorrPubkey=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v1.SchnorrPubkey}
 */
proto.nockchain.common.v1.Lock.prototype.addSchnorrPubkeys = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.nockchain.common.v1.SchnorrPubkey, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v1.Lock} returns this
 */
proto.nockchain.common.v1.Lock.prototype.clearSchnorrPubkeysList = function() {
  return this.setSchnorrPubkeysList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Name.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Name.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Name} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Name.toObject = function(includeInstance, msg) {
  var f, obj = {
first: (f = msg.getFirst()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f),
last: (f = msg.getLast()) && nockchain_common_v1_primitives_pb.Hash.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Name}
 */
proto.nockchain.common.v1.Name.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Name;
  return proto.nockchain.common.v1.Name.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Name} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Name}
 */
proto.nockchain.common.v1.Name.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setFirst(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.Hash;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Hash.deserializeBinaryFromReader);
      msg.setLast(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Name.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Name.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Name} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Name.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirst();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
  f = message.getLast();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.Hash.serializeBinaryToWriter
    );
  }
};


/**
 * optional Hash first = 1;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v1.Name.prototype.getFirst = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 1));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.common.v1.Name} returns this
*/
proto.nockchain.common.v1.Name.prototype.setFirst = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Name} returns this
 */
proto.nockchain.common.v1.Name.prototype.clearFirst = function() {
  return this.setFirst(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Name.prototype.hasFirst = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Hash last = 2;
 * @return {?proto.nockchain.common.v1.Hash}
 */
proto.nockchain.common.v1.Name.prototype.getLast = function() {
  return /** @type{?proto.nockchain.common.v1.Hash} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Hash, 2));
};


/**
 * @param {?proto.nockchain.common.v1.Hash|undefined} value
 * @return {!proto.nockchain.common.v1.Name} returns this
*/
proto.nockchain.common.v1.Name.prototype.setLast = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Name} returns this
 */
proto.nockchain.common.v1.Name.prototype.clearLast = function() {
  return this.setLast(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Name.prototype.hasLast = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Note.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Note.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Note} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Note.toObject = function(includeInstance, msg) {
  var f, obj = {
originPage: (f = msg.getOriginPage()) && nockchain_common_v1_primitives_pb.BlockHeight.toObject(includeInstance, f),
timelock: (f = msg.getTimelock()) && proto.nockchain.common.v1.TimeLockIntent.toObject(includeInstance, f),
name: (f = msg.getName()) && proto.nockchain.common.v1.Name.toObject(includeInstance, f),
lock: (f = msg.getLock()) && proto.nockchain.common.v1.Lock.toObject(includeInstance, f),
source: (f = msg.getSource()) && proto.nockchain.common.v1.Source.toObject(includeInstance, f),
assets: (f = msg.getAssets()) && nockchain_common_v1_primitives_pb.Nicks.toObject(includeInstance, f),
version: (f = msg.getVersion()) && nockchain_common_v1_primitives_pb.NoteVersion.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Note}
 */
proto.nockchain.common.v1.Note.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Note;
  return proto.nockchain.common.v1.Note.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Note} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Note}
 */
proto.nockchain.common.v1.Note.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.BlockHeight;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.BlockHeight.deserializeBinaryFromReader);
      msg.setOriginPage(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v1.TimeLockIntent;
      reader.readMessage(value,proto.nockchain.common.v1.TimeLockIntent.deserializeBinaryFromReader);
      msg.setTimelock(value);
      break;
    case 3:
      var value = new proto.nockchain.common.v1.Name;
      reader.readMessage(value,proto.nockchain.common.v1.Name.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 4:
      var value = new proto.nockchain.common.v1.Lock;
      reader.readMessage(value,proto.nockchain.common.v1.Lock.deserializeBinaryFromReader);
      msg.setLock(value);
      break;
    case 5:
      var value = new proto.nockchain.common.v1.Source;
      reader.readMessage(value,proto.nockchain.common.v1.Source.deserializeBinaryFromReader);
      msg.setSource(value);
      break;
    case 6:
      var value = new nockchain_common_v1_primitives_pb.Nicks;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.Nicks.deserializeBinaryFromReader);
      msg.setAssets(value);
      break;
    case 7:
      var value = new nockchain_common_v1_primitives_pb.NoteVersion;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.NoteVersion.deserializeBinaryFromReader);
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Note.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Note.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Note} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Note.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOriginPage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.BlockHeight.serializeBinaryToWriter
    );
  }
  f = message.getTimelock();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v1.TimeLockIntent.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.nockchain.common.v1.Name.serializeBinaryToWriter
    );
  }
  f = message.getLock();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.nockchain.common.v1.Lock.serializeBinaryToWriter
    );
  }
  f = message.getSource();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.nockchain.common.v1.Source.serializeBinaryToWriter
    );
  }
  f = message.getAssets();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      nockchain_common_v1_primitives_pb.Nicks.serializeBinaryToWriter
    );
  }
  f = message.getVersion();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      nockchain_common_v1_primitives_pb.NoteVersion.serializeBinaryToWriter
    );
  }
};


/**
 * optional BlockHeight origin_page = 1;
 * @return {?proto.nockchain.common.v1.BlockHeight}
 */
proto.nockchain.common.v1.Note.prototype.getOriginPage = function() {
  return /** @type{?proto.nockchain.common.v1.BlockHeight} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.BlockHeight, 1));
};


/**
 * @param {?proto.nockchain.common.v1.BlockHeight|undefined} value
 * @return {!proto.nockchain.common.v1.Note} returns this
*/
proto.nockchain.common.v1.Note.prototype.setOriginPage = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Note} returns this
 */
proto.nockchain.common.v1.Note.prototype.clearOriginPage = function() {
  return this.setOriginPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Note.prototype.hasOriginPage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TimeLockIntent timelock = 2;
 * @return {?proto.nockchain.common.v1.TimeLockIntent}
 */
proto.nockchain.common.v1.Note.prototype.getTimelock = function() {
  return /** @type{?proto.nockchain.common.v1.TimeLockIntent} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.TimeLockIntent, 2));
};


/**
 * @param {?proto.nockchain.common.v1.TimeLockIntent|undefined} value
 * @return {!proto.nockchain.common.v1.Note} returns this
*/
proto.nockchain.common.v1.Note.prototype.setTimelock = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Note} returns this
 */
proto.nockchain.common.v1.Note.prototype.clearTimelock = function() {
  return this.setTimelock(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Note.prototype.hasTimelock = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Name name = 3;
 * @return {?proto.nockchain.common.v1.Name}
 */
proto.nockchain.common.v1.Note.prototype.getName = function() {
  return /** @type{?proto.nockchain.common.v1.Name} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Name, 3));
};


/**
 * @param {?proto.nockchain.common.v1.Name|undefined} value
 * @return {!proto.nockchain.common.v1.Note} returns this
*/
proto.nockchain.common.v1.Note.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Note} returns this
 */
proto.nockchain.common.v1.Note.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Note.prototype.hasName = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Lock lock = 4;
 * @return {?proto.nockchain.common.v1.Lock}
 */
proto.nockchain.common.v1.Note.prototype.getLock = function() {
  return /** @type{?proto.nockchain.common.v1.Lock} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Lock, 4));
};


/**
 * @param {?proto.nockchain.common.v1.Lock|undefined} value
 * @return {!proto.nockchain.common.v1.Note} returns this
*/
proto.nockchain.common.v1.Note.prototype.setLock = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Note} returns this
 */
proto.nockchain.common.v1.Note.prototype.clearLock = function() {
  return this.setLock(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Note.prototype.hasLock = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Source source = 5;
 * @return {?proto.nockchain.common.v1.Source}
 */
proto.nockchain.common.v1.Note.prototype.getSource = function() {
  return /** @type{?proto.nockchain.common.v1.Source} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.Source, 5));
};


/**
 * @param {?proto.nockchain.common.v1.Source|undefined} value
 * @return {!proto.nockchain.common.v1.Note} returns this
*/
proto.nockchain.common.v1.Note.prototype.setSource = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Note} returns this
 */
proto.nockchain.common.v1.Note.prototype.clearSource = function() {
  return this.setSource(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Note.prototype.hasSource = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Nicks assets = 6;
 * @return {?proto.nockchain.common.v1.Nicks}
 */
proto.nockchain.common.v1.Note.prototype.getAssets = function() {
  return /** @type{?proto.nockchain.common.v1.Nicks} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.Nicks, 6));
};


/**
 * @param {?proto.nockchain.common.v1.Nicks|undefined} value
 * @return {!proto.nockchain.common.v1.Note} returns this
*/
proto.nockchain.common.v1.Note.prototype.setAssets = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Note} returns this
 */
proto.nockchain.common.v1.Note.prototype.clearAssets = function() {
  return this.setAssets(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Note.prototype.hasAssets = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional NoteVersion version = 7;
 * @return {?proto.nockchain.common.v1.NoteVersion}
 */
proto.nockchain.common.v1.Note.prototype.getVersion = function() {
  return /** @type{?proto.nockchain.common.v1.NoteVersion} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.NoteVersion, 7));
};


/**
 * @param {?proto.nockchain.common.v1.NoteVersion|undefined} value
 * @return {!proto.nockchain.common.v1.Note} returns this
*/
proto.nockchain.common.v1.Note.prototype.setVersion = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.Note} returns this
 */
proto.nockchain.common.v1.Note.prototype.clearVersion = function() {
  return this.setVersion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.Note.prototype.hasVersion = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.nockchain.common.v1.Signature.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.Signature.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.Signature.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.Signature} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Signature.toObject = function(includeInstance, msg) {
  var f, obj = {
entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    proto.nockchain.common.v1.SignatureEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.Signature}
 */
proto.nockchain.common.v1.Signature.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.Signature;
  return proto.nockchain.common.v1.Signature.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.Signature} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.Signature}
 */
proto.nockchain.common.v1.Signature.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.nockchain.common.v1.SignatureEntry;
      reader.readMessage(value,proto.nockchain.common.v1.SignatureEntry.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.Signature.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.Signature.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.Signature} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.Signature.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.nockchain.common.v1.SignatureEntry.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SignatureEntry entries = 1;
 * @return {!Array<!proto.nockchain.common.v1.SignatureEntry>}
 */
proto.nockchain.common.v1.Signature.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.nockchain.common.v1.SignatureEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.nockchain.common.v1.SignatureEntry, 1));
};


/**
 * @param {!Array<!proto.nockchain.common.v1.SignatureEntry>} value
 * @return {!proto.nockchain.common.v1.Signature} returns this
*/
proto.nockchain.common.v1.Signature.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.nockchain.common.v1.SignatureEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nockchain.common.v1.SignatureEntry}
 */
proto.nockchain.common.v1.Signature.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.nockchain.common.v1.SignatureEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nockchain.common.v1.Signature} returns this
 */
proto.nockchain.common.v1.Signature.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.SignatureEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.SignatureEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.SignatureEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.SignatureEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
schnorrPubkey: (f = msg.getSchnorrPubkey()) && nockchain_common_v1_primitives_pb.SchnorrPubkey.toObject(includeInstance, f),
signature: (f = msg.getSignature()) && proto.nockchain.common.v1.SchnorrSignature.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.SignatureEntry}
 */
proto.nockchain.common.v1.SignatureEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.SignatureEntry;
  return proto.nockchain.common.v1.SignatureEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.SignatureEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.SignatureEntry}
 */
proto.nockchain.common.v1.SignatureEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.SchnorrPubkey;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.SchnorrPubkey.deserializeBinaryFromReader);
      msg.setSchnorrPubkey(value);
      break;
    case 2:
      var value = new proto.nockchain.common.v1.SchnorrSignature;
      reader.readMessage(value,proto.nockchain.common.v1.SchnorrSignature.deserializeBinaryFromReader);
      msg.setSignature(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.SignatureEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.SignatureEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.SignatureEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.SignatureEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSchnorrPubkey();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.SchnorrPubkey.serializeBinaryToWriter
    );
  }
  f = message.getSignature();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.nockchain.common.v1.SchnorrSignature.serializeBinaryToWriter
    );
  }
};


/**
 * optional SchnorrPubkey schnorr_pubkey = 1;
 * @return {?proto.nockchain.common.v1.SchnorrPubkey}
 */
proto.nockchain.common.v1.SignatureEntry.prototype.getSchnorrPubkey = function() {
  return /** @type{?proto.nockchain.common.v1.SchnorrPubkey} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.SchnorrPubkey, 1));
};


/**
 * @param {?proto.nockchain.common.v1.SchnorrPubkey|undefined} value
 * @return {!proto.nockchain.common.v1.SignatureEntry} returns this
*/
proto.nockchain.common.v1.SignatureEntry.prototype.setSchnorrPubkey = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.SignatureEntry} returns this
 */
proto.nockchain.common.v1.SignatureEntry.prototype.clearSchnorrPubkey = function() {
  return this.setSchnorrPubkey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.SignatureEntry.prototype.hasSchnorrPubkey = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SchnorrSignature signature = 2;
 * @return {?proto.nockchain.common.v1.SchnorrSignature}
 */
proto.nockchain.common.v1.SignatureEntry.prototype.getSignature = function() {
  return /** @type{?proto.nockchain.common.v1.SchnorrSignature} */ (
    jspb.Message.getWrapperField(this, proto.nockchain.common.v1.SchnorrSignature, 2));
};


/**
 * @param {?proto.nockchain.common.v1.SchnorrSignature|undefined} value
 * @return {!proto.nockchain.common.v1.SignatureEntry} returns this
*/
proto.nockchain.common.v1.SignatureEntry.prototype.setSignature = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.SignatureEntry} returns this
 */
proto.nockchain.common.v1.SignatureEntry.prototype.clearSignature = function() {
  return this.setSignature(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.SignatureEntry.prototype.hasSignature = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.nockchain.common.v1.SchnorrSignature.prototype.toObject = function(opt_includeInstance) {
  return proto.nockchain.common.v1.SchnorrSignature.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nockchain.common.v1.SchnorrSignature} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.SchnorrSignature.toObject = function(includeInstance, msg) {
  var f, obj = {
chal: (f = msg.getChal()) && nockchain_common_v1_primitives_pb.EightBelt.toObject(includeInstance, f),
sig: (f = msg.getSig()) && nockchain_common_v1_primitives_pb.EightBelt.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nockchain.common.v1.SchnorrSignature}
 */
proto.nockchain.common.v1.SchnorrSignature.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.nockchain.common.v1.SchnorrSignature;
  return proto.nockchain.common.v1.SchnorrSignature.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nockchain.common.v1.SchnorrSignature} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nockchain.common.v1.SchnorrSignature}
 */
proto.nockchain.common.v1.SchnorrSignature.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new nockchain_common_v1_primitives_pb.EightBelt;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.EightBelt.deserializeBinaryFromReader);
      msg.setChal(value);
      break;
    case 2:
      var value = new nockchain_common_v1_primitives_pb.EightBelt;
      reader.readMessage(value,nockchain_common_v1_primitives_pb.EightBelt.deserializeBinaryFromReader);
      msg.setSig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.nockchain.common.v1.SchnorrSignature.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.nockchain.common.v1.SchnorrSignature.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nockchain.common.v1.SchnorrSignature} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.nockchain.common.v1.SchnorrSignature.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChal();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      nockchain_common_v1_primitives_pb.EightBelt.serializeBinaryToWriter
    );
  }
  f = message.getSig();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      nockchain_common_v1_primitives_pb.EightBelt.serializeBinaryToWriter
    );
  }
};


/**
 * optional EightBelt chal = 1;
 * @return {?proto.nockchain.common.v1.EightBelt}
 */
proto.nockchain.common.v1.SchnorrSignature.prototype.getChal = function() {
  return /** @type{?proto.nockchain.common.v1.EightBelt} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.EightBelt, 1));
};


/**
 * @param {?proto.nockchain.common.v1.EightBelt|undefined} value
 * @return {!proto.nockchain.common.v1.SchnorrSignature} returns this
*/
proto.nockchain.common.v1.SchnorrSignature.prototype.setChal = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.SchnorrSignature} returns this
 */
proto.nockchain.common.v1.SchnorrSignature.prototype.clearChal = function() {
  return this.setChal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.SchnorrSignature.prototype.hasChal = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EightBelt sig = 2;
 * @return {?proto.nockchain.common.v1.EightBelt}
 */
proto.nockchain.common.v1.SchnorrSignature.prototype.getSig = function() {
  return /** @type{?proto.nockchain.common.v1.EightBelt} */ (
    jspb.Message.getWrapperField(this, nockchain_common_v1_primitives_pb.EightBelt, 2));
};


/**
 * @param {?proto.nockchain.common.v1.EightBelt|undefined} value
 * @return {!proto.nockchain.common.v1.SchnorrSignature} returns this
*/
proto.nockchain.common.v1.SchnorrSignature.prototype.setSig = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.nockchain.common.v1.SchnorrSignature} returns this
 */
proto.nockchain.common.v1.SchnorrSignature.prototype.clearSig = function() {
  return this.setSig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.nockchain.common.v1.SchnorrSignature.prototype.hasSig = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.nockchain.common.v1);
